import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './Component/Home/Home';
import About from './Component/pages/about';
import Contact from './Component/pages/Contact';
import ServicesOffered from './Component/pages/ServicesOffered';
import Career from './Component/pages/Career';
import Blog from './Component/pages/Blog';
import TermsAndConditions from './Component/pages/TermsAndConditions';
import PrivacyPolicy from './Component/pages/PrivacyPolicy';
import Sitemap from './Component/pages/Sitemap';
import Reviews from './Component/pages/Reviews';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/Services offered" element={<ServicesOffered />} />
      <Route path="/services" element={<ServicesOffered />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/career" element={<Career />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/sitemap" element={<Sitemap />} />
      <Route path="/reviews" element={<Reviews />} />
    </Routes>
  );
}

export default AppRoutes; 